import { ApiProperty } from "@nestjs/swagger";

export class MachineInwordDto {
    @ApiProperty()
    machinedescription: string | null;
    @ApiProperty()
    barcode: string | null;
    @ApiProperty()
    transferDate: any | null;
    @ApiProperty()
    transferStartDate: any;
    @ApiProperty()
    transferEndDate: any;

}

